"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var ComponentWithFormRowWrapper_1 = require("../../utils/hoc/ComponentWithFormRowWrapper");
var DatePicker_1 = require("../DatePicker");
var propTypes = __assign({}, ComponentWithFormRowWrapper_1.withFormRowWrapperPropTypes, { defaultDate: PropTypes.object, excludeDates: PropTypes.array, filterDate: PropTypes.func, includeDates: PropTypes.array, maxDate: PropTypes.object, minDate: PropTypes.object, onChange: PropTypes.func.isRequired, valueDate: PropTypes.object });
// TODO: make defaultProps show up in styleguidist
// it seems the parser can't handle the HOC
var defaultProps = {
    label: undefined,
    description: undefined,
    tooltip: undefined,
    error: false,
    // copy of DatePicker defaultProps for styleguide
    onChange: /* istanbul ignore next */ function () {
        /* empty on purpose */
    },
    excludeDates: undefined,
    filterDate: undefined,
    includeDates: undefined,
    minDate: undefined,
    maxDate: undefined,
    defaultDate: undefined,
    valueDate: undefined,
    placeholder: 'TT.MM.JJJJ'
};
function splitProps(props) {
    var className = props.className, children = props.children, other = __rest(props, ["className", "children"]);
    return ComponentWithFormRowWrapper_1.withFormRowWrapperSplitProps(__assign({ className: classNames('ee_date-picker-row', className) }, other));
}
/**
 * The `DatePickerRow` component integrates a `DatePicker` component into a
 * `FormRow` component.
 *
 * Extending class names are passed to the `FormRow` component and can be
 * defined using the `className` property.
 * All other properties are applied directly to the `DatePicker` component.
 */
exports.DatePickerRow = ComponentWithFormRowWrapper_1.withFormRowWrapper(propTypes, defaultProps, splitProps)(DatePicker_1.DatePicker);
exports.DatePickerRow.displayName = 'DatePickerRow';
exports.default = exports.DatePickerRow;
//# sourceMappingURL=DatePickerRow.js.map
